import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { Link } from 'react-router-dom';
import { rem, themed } from '@/shared/ui/core';

const linkTemplate = css`
 display: inline-block;
 cursor: pointer;
 text-decoration: ${themed('common.linkDecoration')};
 :link, :visited {
   text-decoration: none;
 }
`;

const modifiers = {
  primary: ({ theme }) => ({
    styles: `
      border-bottom-color: ${theme.primary.link};
      border-bottom-style: solid;
      border-bottom-width: ${rem(theme.button.text.borderWidth)};
      border-radius: 0;
      color: ${theme.primary.link};
      font-weight: 700;
      padding: ${theme.button.text.padding};
    `,
  }),
  secondary: ({ theme }) => ({
    styles: `
      font-weight: 700;
      color: ${theme.primary.main};
    `,
  }),
  alertTag: ({ theme }) => ({
    styles: `
      color: ${theme.primary.main};
      font-weight: 700;
      font-size: 0.75rem;
    `,
  }),
  inverted: ({ theme }) => ({
    styles: `
      font-weight: 700;
      color: ${theme.primary.contrastText};
    `,
  }),
};

export const LinkStyled = styled(Link).attrs({
  className: 'component__link',
  role: 'link',
})`
  ${linkTemplate}
  ${applyStyleModifiers(modifiers)};
`;

export const AStyled = styled.a.attrs({
  className: 'component__link',
  role: 'link',
})`
  ${linkTemplate}
  ${applyStyleModifiers(modifiers)};
`;
